import { render, staticRenderFns } from "./Affiliate.vue?vue&type=template&id=7265756e&"
import script from "./Affiliate.vue?vue&type=script&lang=js&"
export * from "./Affiliate.vue?vue&type=script&lang=js&"
import style0 from "./Affiliate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports